module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaCargadorDerecha-ap-e689dc1f.png";